// Opções de horário pra lista suspensa do app (SelectPicker), no lugar do
// <input type="time"> nativo — que abre um seletor diferente em cada
// navegador/celular, fora do padrão visual do app. Usado no expediente do
// usuário (Users.vue) e no horário de funcionamento das unidades
// (Establishments.vue).

export const TIME_STEP_MINUTES = 15

// "08:00:00" / "08:00" → "08:00" (o backend às vezes devolve com segundos).
export const toHHMM = (t) => (t ? String(t).slice(0, 5) : '')

const toMinutes = (t) => {
  const [h, m] = toHHMM(t).split(':').map(Number)
  return (h || 0) * 60 + (m || 0)
}

const fromMinutes = (total) =>
  `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`

// Horários de `step` em `step` minutos entre min e max (inclusive) — sempre
// incluindo os próprios limites e o valor atual, mesmo fora da grade (ex:
// 08:10), pra nunca sumir um horário já salvo.
export function timeOptions(min, max, current, step = TIME_STEP_MINUTES) {
  const from = toMinutes(min || '00:00')
  const to = toMinutes(max || '23:59')
  const values = new Set()
  for (let t = Math.ceil(from / step) * step; t <= to; t += step) {
    values.add(fromMinutes(t))
  }
  ;[min, max, current].filter(Boolean).forEach((t) => values.add(toHHMM(t)))
  return [...values].sort().map((v) => ({ value: v, label: v }))
}
